import {
  SB,
  createSharedStateComputedProperties,
  searchableComputedProperty,
} from '@play-co/replicant';
import { teamCompetitionSharedStateSchema } from './teamCompetition.schema';

export const teamCompetitionComputedProperties =
  createSharedStateComputedProperties(teamCompetitionSharedStateSchema)({
    teams: searchableComputedProperty(
      SB.array(
        SB.object({
          teamId: SB.string(),
          createdAt: SB.int(),
        }),
      ),
      (state) => {
        return Object.keys(state.global.teams).map((teamId) => ({
          teamId,
          ...state.global.teams[teamId],
        }));
      },
    ),

    teamsCount: searchableComputedProperty(SB.int(), (state) => {
      return Object.keys(state.global.teams).length;
    }),
  });
